import React from "react";
import { TestLLMClassifierAgreementResult } from "models/LLMs/Testing/TestLLMClassifierAgreementResult";
import { ErrorExplanation } from "../ErrorExplanation";
import { LLMExecutionResultInformation } from "../LLMExecutionResultInformation";
import { TestedConversationDetails } from "../TestedConversationDetails";
import { ResultActions } from "./ResultActions";

interface ErrorResultProps {
    result: TestLLMClassifierAgreementResult;
    number: number;
}

export function ErrorResult({ result, number }: ErrorResultProps) {
    return (
        <React.Fragment>
            <TestedConversationDetails
                conversation={result.conversation}
                number={number}
                wouldExecuteUnderConditions={result.wouldExecuteUnderConditions}
                labels={{
                    human: result.conversation.labeled,
                    model: result.decision,
                }}
                source={result.conversation.isSynthetic ? "synthetic" : "human"}
            />
            {result.errors.map((error, i) => (
                <ErrorExplanation error={error} key={i} />
            ))}
            {result.executionResult && (
                <LLMExecutionResultInformation
                    executionResult={result.executionResult}
                >
                    <LLMExecutionResultInformation.StepRunInformation />
                    <LLMExecutionResultInformation.StepVariables />
                    <LLMExecutionResultInformation.ClassifierResultsToWrite />
                    <LLMExecutionResultInformation.ExtendedMetadataToWrite />
                </LLMExecutionResultInformation>
            )}
            <ResultActions result={result} />
        </React.Fragment>
    );
}
